module.exports = __webpack_public_path__ + "onboarding-environments.d58c65ea5e37fc3552d86207231662eb.hashedasset.svg";